
import { Checkbox, Col, Form } from "antd";
import { FC } from "react";
import { MazakaCheckboxProps } from "models/Client/MazakaCheckboxProps";

export const MazakaCheckbox: FC<MazakaCheckboxProps> = (props) => {
  return (
    <Col
      span={props.span ?? 24}
      xs={props.xs}
      sm={props.sm}
      md={props.md}
      lg={props.lg}
      xl={props.xl}
      xxl={props.xxl}
    >
      <Form.Item
        className={props.className}
        name={props.name}
        initialValue={props.initialValue}
        rules={[
          ...(props.rules ?? []), // Kullanıcının eklediği diğer kuralları koruyoruz
          {
            validator: (_, value) => {
              if (props.rules?.some((rule:any) => rule?.required) && !value) {
                return Promise.reject("Kutucuğu işaretleyin.");
              }
              return Promise.resolve();
            },
          },
        ]}
        colon={props.colon}
        label={props.label}
        labelAlign={props.labelAlign}
        labelCol={props.labelCol}
        wrapperCol={props.wrapperCol}
        hasFeedback={props.hasFeedback}
        tooltip={props.tooltip}
        valuePropName="checked"
        noStyle={props.noStyle}
        help={props.help}
        
     
      >
        <div className="!flex items-start gap-2">
        <Checkbox
          autoFocus={props.autoFocus}
          defaultChecked={props.defaultChecked}
          disabled={props.disabled}
          indeterminate={props.indeterminate}
          onChange={props.onChange}
          required={props.checkboxRequired}
         
         
          
        />
 
          {props.text}

        </div>
      </Form.Item>
    </Col>
  );
};
